import { useEffect, useState } from 'react';

import { fetchCurrencies } from '../api';

const useCurrencies = () => {
  const [currencies, setCurrencies] = useState({
    availableCurrencies: [],
    fiatCurrencies: [],
    cryptoCurrencies: []
  });

  useEffect(async () => {
    const availableCurrencies = await fetchCurrencies();

    const fiatCurrencies = await availableCurrencies.filter((currency) => currency.type === 'FIAT');
    const cryptoCurrencies = await availableCurrencies.filter(
      (currency) => currency.type === 'CRYPTO'
    );

    setCurrencies({ availableCurrencies, fiatCurrencies, cryptoCurrencies });
  }, []);

  return { ...currencies };
};

export { useCurrencies };
